
// ==============================|| LOGO SVG ||============================== //

const HookoffDelIcon = ({ color = '#3B66B0', width = 22, className = 'abc' }) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
    
      <g>
        <g>
          <path fill={color} d="M8.6,19.2c-0.1,0-0.1,0-0.2,0c-1.7,0-3-1.3-3-3h2.7c0-0.1,0-0.2,0-0.3l-4.7-4.7v5c0,2.3,1.6,4.3,3.8,4.8
            c0.8,0.2,1.6,0.1,2.4-0.1C9.2,20.4,8.9,19.9,8.6,19.2z"/>
          <path fill={color} d="M11.4,9.1v1.3v0.2c0.6-0.4,1.3-0.7,2-0.8V9.1c2.1-0.6,3.4-2.8,2.9-4.9c-0.5-2.2-2.7-3.4-4.9-2.9
            C9.3,1.9,8,4,8.5,6.2C8.9,7.6,10,8.7,11.4,9.1z M12.4,3.2c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2
            C10.4,4.1,11.3,3.2,12.4,3.2z"/>
        </g>
        <g>
          <polygon fill={color} points="17.3,13.7 15.2,15.8 13.2,13.7 12.4,14.5 14.4,16.6 12.4,18.6 13.2,19.4 15.2,17.4 17.3,19.4 
            18.1,18.6 16.1,16.5 18.1,14.5"/>
          <path fill={color} d="M19.3,12.5c-0.5-0.5-1.1-0.9-1.8-1.2c-0.7-0.3-1.5-0.5-2.2-0.5c-0.8,0-1.5,0.1-2.2,0.5
            c-0.7,0.3-1.3,0.7-1.8,1.2c-0.5,0.5-0.9,1.1-1.2,1.8c-0.3,0.7-0.5,1.5-0.5,2.2c0,0.8,0.1,1.5,0.5,2.2c0.3,0.7,0.7,1.3,1.2,1.8
            c0.5,0.5,1.1,0.9,1.8,1.2s1.5,0.5,2.2,0.5c0.8,0,1.5-0.1,2.2-0.5c0.7-0.3,1.3-0.7,1.8-1.2c0.5-0.5,0.9-1.1,1.2-1.8
            c0.3-0.7,0.5-1.5,0.5-2.2c0-0.8-0.1-1.5-0.5-2.2C20.2,13.6,19.8,13,19.3,12.5z M18.5,19.8c-0.9,0.9-2,1.3-3.2,1.3
            s-2.4-0.5-3.2-1.3c-0.9-0.9-1.3-2-1.3-3.2s0.5-2.4,1.3-3.2c0.9-0.9,2-1.3,3.2-1.3s2.4,0.5,3.2,1.3c0.9,0.9,1.3,2,1.3,3.2
            S19.3,19,18.5,19.8z"/>
        </g>
      </g>
    </svg>
  );
};

export default HookoffDelIcon;
